import React, {useEffect} from 'react';
import {Redirect, Route, Switch, useRouteMatch, NavLink} from 'react-router-dom';
import Lotto5DashboardMix from '../lotto/lotto5';
import Lotto6DashboardMix from '../lotto/lotto6';
import Lotto12DashboardMix from '../lotto/lotto12';
import Lotto5D from '../lotto5d/mobile';
import Lotto12v2 from '../lotto12v3/mobile';
import Lotto90 from '../lotto90/mobile';
import Lotto99 from '../lotto99/mobile';
import Roulette from '../roulette/mobile';
import withAuth from '../../routes/withAuth';
import "../../assets/css/mobile-nav.css";
import CustomSound from "./CustomSound";


const MobileRoute = () => {
    const {path, url} = useRouteMatch();
    const isNotIframe = false;
    const appClass = `mobile-app ${isNotIframe ? "mobile-stand-alone" : ""}`;

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const notifies = document.getElementsByClassName("ui-pnotify-container");
            for (let i = 0; i < notifies.length; i++) {
                notifies[i].classList.add("mobile-notify");
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, [])

    const games = [
        {to: `${url}/lottery5`, label: "Lotto 5"},
        {to: `${url}/lottery6`, label: "Lotto 6"},
        {to: `${url}/lottery12`, label: "Lotto 12"},
        {to: `${url}/lottery1/12`, label: "Yuki"},
        {to: `${url}/lottery90`, label: "Lotto 90"},
        {to: `${url}/lottery5D`, label: "Lotto 5D"},
        {to: `${url}/lottery99`, label: "Lotto 1/99"},
        {to: `${url}/lottery1-36`, label: "Lotto 1/36"},
    ];

    return (
        <div className={appClass}>
            <CustomSound isNotIframe={isNotIframe}/>
            <Switch>
                <Route exact path={`${path}/lottery5`} component={withAuth(Lotto5DashboardMix, appClass)}/>
                <Route exact path={`${path}/lottery6`} component={withAuth(Lotto6DashboardMix, appClass)}/>
                <Route exact path={`${path}/lottery12`} component={withAuth(Lotto12DashboardMix, appClass)}/>
                <Route exact path={`${path}/lottery5D`} component={withAuth(Lotto5D)}/>
                <Route exact path={`${path}/lottery1/12`} component={withAuth(Lotto12v2, appClass)}/>
                <Route exact path={`${path}/lottery90`} component={withAuth(Lotto90, appClass)}/>
                <Route exact path={`${path}/lottery99`} component={withAuth(Lotto99, appClass)}/>
                <Route exact path={`${path}/lottery1-36`} component={withAuth(Roulette, appClass)}/>
                <Redirect to={`${url}/lottery5`}/>
            </Switch>
            <div className="mobile-bottom-nav">
                <div className="mobile-bottom-nav-scroll">
                    {games.map(game => (
                        <NavLink
                            key={game.to}
                            to={game.to}
                            exact
                            className="mobile-nav-item"
                            activeClassName="active"
                        >
                            {game.label}
                        </NavLink>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MobileRoute;
